import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Tab, Nav, ProgressBar } from "react-bootstrap";
import SupportingVideo from "../user/supportvideo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  BreadcrumsIcon,
  CheckedIcon,
  ModuleAnyIcon,
  ModuleLeaderIcon,
  ModulePlayIcon,
  ModuleQuizIcon,
  ModuleSOPIcon,
  ModuleVideoIcon,
  QueryIcon,
} from "../../../SvgIconsData";
import UserQuiz from "../user/userQuiz/UserQuiz";
import Leaderboard from "../user/leaderboard/Leaderboard";
import UserAnalytic from "../user/userAnalytic/UserAnalytic";
import PlayComp from "./PlayComp";
import DownloadLauncher from "../launcher/DownloadLauncher";
import SOP from "../user/courses/SOP";
import { CrownIcon, DownloadIcon, SpinnerIcon } from "../../../assets/icons/iconshere";
import { certificateDownload } from "../../../utils/useWindowDimensions";
import ModuleReview from "./moduleReview";
import ChatBot from "../Admin/ChatBot";
import ProPopup from "../../layouts/ProPopup";
import LMSPlay from "../LMS/LMSPlay";
import RaiseQueryForm from "../Modal/raiseAquery";
import Asset3DModal from "../Asset3DModal/asset3DModal";
import SummarizeAnalytics from "../Admin/SummarizeAnalytics";
import UserLiveShare from "../user/liveshare/liveshare";
import StreamIcon from '@mui/icons-material/Stream';

const ModuleDetails = () => {
  let params = useParams();
  const moduleUUID = params.uuid;
  const aboutRef = useRef(null);
  const outcomesRef = useRef(null);
  const reviewsRef = useRef(null);
  const [activeSection, setActiveSection] = useState("section-about");
  const userData = useSelector((state) => state.userSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const configData = useSelector((state) => state.configSlice);
  const appData = useSelector((state) => state.applicationSlice);
  const navigate = useNavigate();
  const location = useLocation();
  let MODE = configData.config.MODE;
  const [showLauncher, setShowLauncher] = useState(false);
  const [spinnerIndex, setSpinnerIndex] = useState(null);
  const [moduleDetails, setModuleDetails] = useState({
    name: "",
    short: "",
    versions: [
      {
        data: {
          thumbnail: "",
          media: [],
        },
      },
    ],
  });
  const previewTime = configData.config.previewTime || 0;
  const [availablePlatform, setAvailablePlatform] = useState([]);
  const [aboutData, setAboutData] = useState([]);
  const [outcomesData, setOutcomesData] = useState([]);
  const [linkedAssetList, setLinkedAssetList] = useState([]);
  const [tabActiveKey, setTabActiveKey] = useState("play");
  const [userUUID, setUserUUID] = useState("");
  const [description, setDescription] = useState("");
  const [assignedToUser, setAssignedToUser] = useState(false);
  const [courseDuration, setCourseDuration] = useState(0);
  const [average, setAverage] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);
  const [certificate, setCertificate] = useState({});
  const [showQueryForm, setShowQueryForm] = useState(false);
  const [previousRoute, SetPreviousRoute] = useState({
    path: null,
    status: false,
  });
  const [isSubmitted, setSubmitted] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState({});
  const [videoList, setVideoList] = useState([]);
  const [sopUploaded, setSopUploaded] = useState(false);
  const [showTab, setShowTab] = useState({
    sop: false,
    quiz: false,
  });
  const [sopSuggestions, setSopSuggestions] = useState([]);
  const platformId = appData.tags.data.children.filter((e) => e.name == "Platform")[0]?.id || 0;
  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);
  const [aiPayloadData, setAiPayloadData] = useState({});
  const [showPopup, setShowPopup] = useState({
    chatbot: false,
    aiAnalytics: false,
  });

  const apiRoute = {
    XR: {
      BASIC_DETAILS: `api/resource/module/basic/${moduleUUID}`,
    },
    "2D": {
      BASIC_DETAILS: `api/resource/2d/lms/basic/details/${moduleUUID}`,
    },
  };

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location?.state?.previousLocationPathname) {
      SetPreviousRoute({
        path: location.state.previousLocationPathname || "/explore",
        status: true,
      });
    }
    if (location.state && "userUUID" in location.state) {
      setUserUUID(location.state.userUUID);
    }
  }, [location]);

  const LauncherDownload = () => {
    setShowLauncher(true);
  };

  const getCertificateData = async () => {
    try {
      const response = await axios.get(
        `${configData.config.API_URL}/api/dashboard/check/resource/certificate/${userData.user.uuid}/${moduleUUID}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
      setCertificate(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      getCertificateData();
    }
  }, []);

  const getModuleBasicDetail = async () => {
    try {
      const response = await axios.get(`${configData.config.UNO_URL}/${apiRoute[MODE]["BASIC_DETAILS"]}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });

      const _platformList = response?.data?.data?.tags?.filter((e) => e.categoryId == platformId) || [];
      setAboutData(response?.data?.data?.versions[0]?.data?.learningPoints || []);

      setOutcomesData(response.data.data.versions[0].data.outcomesPoints || []);
      setCourseDuration(response?.data?.data?.versions[0]?.data?.courseDuration || 0);
      setDescription(response?.data?.data?.versions[0]?.data?.description || "");
      setAvailablePlatform(_platformList);
      setModuleDetails({ ...response?.data?.data });
      setAssignedToUser(response.data.data.assigned);
    } catch (error) {
      console.log(error);
    }
  };

  const getModulePreLoginDetail = async () => {
    try {
      const response = await axios.get(`${configData.config.UNO_URL}/api/resource/preDetails/${moduleUUID}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      const _platformList = response.data.data.tags.filter((e) => e.categoryId == platformId);
      setCourseDuration(response?.data?.data?.versions[0]?.data?.courseDuration || 0);
      setAboutData(response?.data?.data?.versions[0]?.data?.learningPoints || []);
      setOutcomesData(response.data.data.versions[0].data.outcomesPoints || []);
      setAvailablePlatform(_platformList);
      setModuleDetails({ ...response?.data?.data });
    } catch (error) {
      console.log(error);
    }
  };

  const get3DAssetList = async () => {
    try {
      let { data } = await axios.get(`${configData.config.UNO_URL}/api/resource/xr/linked/assets/${moduleUUID}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });

      setLinkedAssetList(data.data.linkedResources);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (moduleUUID?.length > 0) {
      if (isLoggedIn) {
        getModuleBasicDetail();
      } else if (MODE === "XR") {
        getModulePreLoginDetail();
      }

      if (isLoggedIn && MODE === "XR") {
        getModuleVideo();
        get3DAssetList();
      }
    }
  }, [moduleUUID, platformId]);

  const handleCertificateDownload = async () => {
    if (userPlan?.myCertificate?.download) {
      if ("uuid" in certificate) {
        if (spinnerIndex) return;
        setSpinnerIndex(true);
        await certificateDownload({
          certificate,
          certificateData: configData.config,
          moduleName: moduleDetails.name,
          userData: userData.user,
          outcomesData,
          courseDuration,
          certificateConfig: userData.certificate,
        });
        setSpinnerIndex(false);
      }
    } else {
      setOpenPro(true);
    }
  };

  const handleQueryForm = async () => {
    setShowQueryForm(true);
  };

  const setToPlay = () => {
    setTabActiveKey("play");
  };

  const handleChangeActiveKey = (selectedTab) => {
    setTabActiveKey(selectedTab);
  };

  const handleSetToAbout = () => {
    setActiveSection("sectionAbout");
    const yOffset = -150;
    const y = aboutRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const scrollToSection = (ref, event, sectionName) => {
    event.preventDefault();
    const section = ref.current;
    if (section) {
      setActiveSection(sectionName);
      const yOffset = -150;
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const getModuleVideo = async () => {
    try {
      let response = await axios.get(`${configData.config.UNO_URL}/api/resource/module/video/${moduleUUID}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      let allList = response?.data?.data?.children[0]?.versions[0]?.data?.docs || [];
      let list = allList.filter((e) => e.visible == true);
      setVideoList([...list]);
      setSelectedVideo({ ...list[0] });
    } catch (error) {
      console.log(error);
    }
  };

  const checkSopUploaded = async () => {
    try {
      const { data } = await axios.post(`${configData.config.OPEN_AI_URL}/checkdoc`, {
        uuid: moduleUUID,
      });

      if (data.status === true) {
        let { data } = await axios.get(`${configData.config.UNO_URL}/api/resource/check/sopUpload/${moduleUUID}`);

        if (data.pdfAvailable) setSopUploaded(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getModuleSuggestions = async () => {
    try {
      const { data } = await axios.post(`${configData.config.OPEN_AI_URL}/generatequestions`, {
        uuid: moduleUUID,
        count: "2",
      });

      const splitData = data.result
        .split("\n")
        .filter((item) => item.trim() !== "")
        .map((item) => item.replace(/^\d+\.\s*/, ""));
      setSopSuggestions(splitData);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (MODE === "XR") {
      checkSopUploaded();
      getModuleSuggestions();
    }
  }, []);

  const handleClickHome = () => {
    if (MODE === "2D") {
      navigate(`/2d/lms/dashboard/${userData.user.uuid}`);
      return;
    }
    navigate(`/dashboard/${userData.user.uuid}`);
  };

  return (
    <>
      <div className="playmodule">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="Breadcrums">
                <span onClick={isLoggedIn ? () => handleClickHome() : null}>Home</span>

                {previousRoute.status && (
                  <span onClick={() => navigate(-1)}>
                    <BreadcrumsIcon />{" "}
                    {previousRoute.path.replace("/", "").charAt(0).toUpperCase() +
                      previousRoute.path.replace("/", "").slice(1)}
                  </span>
                )}

                <span className="active">
                  <BreadcrumsIcon /> {moduleDetails.name || ""}
                </span>
              </div>
            </div>
          </div>
        </div>

        <Tab.Container activeKey={tabActiveKey} onSelect={handleChangeActiveKey}>
          <div className="container mt-3">
            <div className="tabanddown">
              <Nav variant="pills" className="module-tab">
                <Nav.Item>
                  <Nav.Link eventKey="play">
                    <ModulePlayIcon />
                    Play
                  </Nav.Link>
                </Nav.Item>

                {isLoggedIn && (
                  <>
                    {videoList.length > 0 && (
                      <Nav.Item>
                        <Nav.Link eventKey="supportVideo">
                          <ModuleVideoIcon />
                          Video Library {userPlan && !userPlan?.courseDetail?.video && <CrownIcon />}
                        </Nav.Link>
                      </Nav.Item>
                    )}

                    {MODE === "XR" && showTab.quiz && (
                      <Nav.Item>
                        <Nav.Link eventKey="quiz">
                          <ModuleQuizIcon />
                          Quiz {userPlan && !userPlan?.courseDetail?.quiz && <CrownIcon />}
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    {MODE === "XR"  && (
                      <Nav.Item>
                        <Nav.Link eventKey="liveshare">
                          <StreamIcon  />
                          Live Share
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    {MODE === "XR" && (
                      <Nav.Item>
                        <Nav.Link eventKey="leaderboard">
                          <ModuleLeaderIcon />
                          Leaderboard
                        </Nav.Link>
                      </Nav.Item>
                    )}

                    {MODE === "XR" && userData.user.permissions.includes("XR.DASHBOARD.OWN") && (
                      <Nav.Item>
                        <Nav.Link eventKey="analytics">
                          <ModuleAnyIcon />
                          AI Analytics {userPlan && !userPlan?.courseDetail?.analytics && <CrownIcon />}
                        </Nav.Link>
                      </Nav.Item>
                    )}

                    {showTab.sop && (
                      <Nav.Item>
                        <Nav.Link eventKey="sop">
                          <ModuleSOPIcon />
                          Knowledge Base {userPlan && !userPlan?.courseDetail?.sop && <CrownIcon />}
                        </Nav.Link>
                      </Nav.Item>
                    )}

                    {MODE === "XR" && linkedAssetList.length > 0 && (
                      <Nav.Item>
                        <Nav.Link eventKey="threeDAsset">
                          <ModuleSOPIcon />
                          3D Asset
                        </Nav.Link>
                      </Nav.Item>
                    )}
                  </>
                )}

                <Nav.Item>
                  <Nav.Link
                    onClick={() => {
                      handleQueryForm();
                    }}
                  >
                    <QueryIcon />
                    Raise Query
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <div className="launch-down">
                {/* {MODE === "XR" && (
                  <span onClick={LauncherDownload}>
                    <DownloadIcon />
                    Launcher
                  </span>
                )} */}

                <span className={"uuid" in certificate ? "" : "disable_cert"} onClick={handleCertificateDownload}>
                  {spinnerIndex ? <SpinnerIcon /> : <DownloadIcon />}
                  Certificate
                </span>
              </div>
            </div>
          </div>

          <Tab.Content className="mt-4 mb-2">
            <Tab.Pane eventKey="play">
              {MODE == "XR" ? (
                <PlayComp
                  moduleDetails={moduleDetails}
                  average={average}
                  courseDuration={courseDuration}
                  totalReviews={totalReviews}
                  availablePlatform={availablePlatform}
                  isLoggedIn={isLoggedIn}
                  handleSetToAbout={handleSetToAbout}
                  previewTime={previewTime}
                  assignedToUser={assignedToUser}
                  video={videoList.length > 0 ? videoList[0] : {}}
                />
              ) : (
                <LMSPlay moduleDetails={moduleDetails} />
              )}
            </Tab.Pane>

            {isLoggedIn && (
              <>
                <Tab.Pane eventKey="supportVideo">
                  <SupportingVideo
                    userPlan={userPlan}
                    selectedVideo={selectedVideo}
                    videoList={videoList}
                    setSelectedVideo={setSelectedVideo}
                  />
                </Tab.Pane>

                <Tab.Pane eventKey="leaderboard">
                  <Leaderboard />
                </Tab.Pane>

                <Tab.Pane eventKey="quiz">
                  <UserQuiz userPlan={userPlan} setShowTab={() => setShowTab((pre) => ({ ...pre, quiz: true }))} />
                </Tab.Pane>
                <Tab.Pane eventKey="liveshare">
                  <UserLiveShare />
                </Tab.Pane>

                <Tab.Pane eventKey="analytics">
                  <UserAnalytic
                    tabActiveKey={tabActiveKey}
                    type="playModuleUser"
                    userUUID={userUUID}
                    setToPlay={setToPlay}
                    setAiPayloadData={setAiPayloadData}
                  />
                </Tab.Pane>

                <Tab.Pane eventKey="sop">
                  <SOP
                    MODE={MODE}
                    userPlan={userPlan}
                    setShowTab={() => setShowTab((pre) => ({ ...pre, sop: true }))}
                  />
                </Tab.Pane>

                <Tab.Pane eventKey="threeDAsset">
                  <Asset3DModal linkedAssetList={linkedAssetList} />
                </Tab.Pane>
              </>
            )}
          </Tab.Content>
        </Tab.Container>

        {(tabActiveKey == "play" || tabActiveKey == "supportVideo") && (
          <div className="container">
            <div className="row">
              <div className="about-section forlms">
                <a
                  className={`section-about ${activeSection === "section-about" ? "active" : ""}`}
                  href="#section-about"
                  onClick={(e) => scrollToSection(aboutRef, e, "section-about")}
                >
                  About
                </a>

                <a
                  className={`section-outcomes ${activeSection === "section-outcomes" ? "active" : ""}`}
                  href="#section-outcomes"
                  onClick={(e) => scrollToSection(outcomesRef, e, "section-outcomes")}
                >
                  Outcomes
                </a>

                <a
                  className={`section-reviews ${activeSection === "section-reviews" ? "active" : ""}`}
                  href="#section-reviews"
                  onClick={(e) => scrollToSection(reviewsRef, e, "section-reviews")}
                >
                  Reviews
                </a>
              </div>

              <div id="section-about" className="about-info" ref={aboutRef}>
                <div className="course-overview pt-2">
                  <div className="course-name-title">
                    <h5>{moduleDetails.name || ""}</h5>
                    <div className="description">
                      <p dangerouslySetInnerHTML={{ __html: description }} />
                    </div>
                  </div>
                </div>
              </div>

              <div id="section-outcomes" className="about-info" ref={outcomesRef}>
                <h5>What you'll learn</h5>
                <div className="bullet-points">
                  {aboutData.map((e, i) => {
                    return (
                      <span key={i}>
                        {" "}
                        <CheckedIcon /> {e}{" "}
                      </span>
                    );
                  })}
                </div>
              </div>

              <div id="section-outcomes" className="about-info" ref={outcomesRef}>
                <h5>Outcomes</h5>
                <div className="bullet-points">
                  {outcomesData.map((e, i) => {
                    return (
                      <span key={i}>
                        <CheckedIcon /> {e}{" "}
                      </span>
                    );
                  })}
                </div>
              </div>

              <div id="section-reviews" className="about-info reviews-main mt-4" ref={reviewsRef}>
                <ModuleReview setRatingAverage={setAverage} setTotalReviews={setTotalReviews} />
              </div>
            </div>
          </div>
        )}
      </div>

      {MODE === "XR" && (
        <DownloadLauncher availablePlatform={availablePlatform} show={showLauncher} handleClose={setShowLauncher} />
      )}

      {MODE === "XR" && configData.config.ChatBot && sopUploaded && (
        <ChatBot
          moduleUUID={moduleUUID}
          sopSuggestions={sopSuggestions}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
        />
      )}
      {MODE === "XR" && aiPayloadData?.sessions?.length > 0 && tabActiveKey === "analytics" && (
        <SummarizeAnalytics
          isChatbotVisible={MODE === "XR" && configData.config.ChatBot && sopUploaded}
          aiPayloadData={aiPayloadData}
          moduleId={moduleUUID}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
        />
      )}
      <ProPopup openPro={openPro} setOpenPro={setOpenPro} />

      {showQueryForm && (
        <RaiseQueryForm
          moduleDetails={moduleDetails}
          isLoggedIn={isLoggedIn}
          isSubmitted={isSubmitted}
          setSubmitted={setSubmitted}
          showQueryForm={showQueryForm}
          setShowQueryForm={setShowQueryForm}
        />
      )}
    </>
  );
};

export default ModuleDetails;
